// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pill-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.pill-container__header {
  height: 145px;
  background-image: linear-gradient(5deg, #9285f9 0%, #3b4aff 100%);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.pill-container__header .back-page {
  display: flex;
  align-items: center;
  text-decoration: none;
  margin-left: -6px;
}
.pill-container .previousAndNextPage {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 24px 6px 30px;
}
.pill-container .previousAndNextPage a {
  display: flex;
  align-items: center;
}
.pill-container .previousAndNextPage .pill-disabled {
  text-decoration: none;
  cursor: no-drop;
}
.pill-container .text-container p {
  white-space: pre-line;
}
.pill-container .image-container {
  width: 100%;
  float: left;
  padding: 30px 0;
}
.pill-container .image-container img {
  width: 100%;
}
.pill-container .media-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 100%;
  height: 210px;
  padding: 14px;
  margin: 24px 0;
  border-radius: 4.91px 24.54px 24.54px 24.54px;
  background-color: #fff;
  box-shadow: 0 4px 4px 2px rgba(0, 0, 0, 0.05);
}
.pill-container .media-container iframe {
  width: 100%;
  height: 100%;
  border-radius: 4.91px 24.54px 24.54px 24.54px;
}
@media (max-width: 768px) {
  .pill-container__header {
    height: 176px;
    background-image: linear-gradient(25deg, #9285f9 0%, #cd5be8 100%);
    padding: 0 16px;
    margin: 0 -16px;
  }
  .pill-container__header .breadcrump {
    display: none;
  }
  .pill-container__body-mobile {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    padding-top: 16px;
  }
  .pill-container__body-mobile .text-container {
    text-align: left;
  }
}
@media (min-width: 769px) {
  .pill-container__header {
    border-radius: 8px;
    justify-content: space-evenly;
    padding: 0 16px;
  }
  .pill-container__header .back-page {
    display: none;
  }
  .pill-container .media-container {
    max-width: 50%;
    height: 380px;
    margin: 30px 30px 30px 0;
  }
  .pill-container .text-container {
    padding-top: 30px;
  }
  .pill-container .image-container {
    width: 50%;
    padding: 30px 30px 30px 0;
  }
}

@media (min-width: 560px) {
  .wrapper-pill-internal {
    padding-top: 15px;
  }
}
@media (min-width: 1024px) {
  .wrapper-pill-internal {
    padding-left: 30px;
    padding-right: 30px;
  }
}
@media (min-width: 1280px) {
  .wrapper-pill-internal {
    padding-left: 80px;
    padding-right: 80px;
    padding-bottom: 50px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/pill-content/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AACF;AACE;EACE,aAAA;EACA,iEAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;AACJ;AACI;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;AACN;AAGE;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,sBAAA;AADJ;AAGI;EACE,aAAA;EACA,mBAAA;AADN;AAII;EACE,qBAAA;EACA,eAAA;AAFN;AAOI;EACE,qBAAA;AALN;AASE;EACE,WAAA;EACA,WAAA;EACA,eAAA;AAPJ;AASI;EACE,WAAA;AAPN;AAWE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;EACA,6CAAA;EACA,sBAAA;EACA,6CAAA;AATJ;AAWI;EACE,WAAA;EACA,YAAA;EACA,6CAAA;AATN;AAaE;EACE;IACE,aAAA;IACA,kEAAA;IACA,eAAA;IACA,eAAA;EAXJ;EAaI;IACE,aAAA;EAXN;EAeE;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,SAAA;IACA,iBAAA;EAbJ;EAeI;IACE,gBAAA;EAbN;AACF;AAgBE;EACE;IACE,kBAAA;IACA,6BAAA;IACA,eAAA;EAdJ;EAgBI;IACE,aAAA;EAdN;EAkBE;IACE,cAAA;IACA,aAAA;IACA,wBAAA;EAhBJ;EAmBE;IACE,iBAAA;EAjBJ;EAoBE;IACE,UAAA;IACA,yBAAA;EAlBJ;AACF;;AAuBE;EADF;IAEI,iBAAA;EAnBF;AACF;AAqBE;EALF;IAOM,kBAAA;IACA,mBAAA;EAnBJ;AACF;AAqBE;EAXF;IAaM,kBAAA;IACA,mBAAA;IACA,oBAAA;EAnBJ;AACF","sourcesContent":[".pill-container {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  &__header {\n    height: 145px;\n    background-image: linear-gradient(5deg, #9285f9 0%, #3b4aff 100%);\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n\n    .back-page {\n      display: flex;\n      align-items: center;\n      text-decoration: none;\n      margin-left: -6px;\n    }\n  }\n\n  .previousAndNextPage {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    padding: 24px 6px 30px;\n\n    a {\n      display: flex;\n      align-items: center;\n    }\n\n    .pill-disabled {\n      text-decoration: none;\n      cursor: no-drop;\n    }\n  }\n\n  .text-container {\n    p {\n      white-space: pre-line;\n    }\n  }\n\n  .image-container {\n    width: 100%;\n    float: left;\n    padding: 30px 0;\n\n    img {\n      width: 100%;\n    }\n  }\n\n  .media-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    max-width: 100%;\n    height: 210px;\n    padding: 14px;\n    margin: 24px 0;\n    border-radius: 4.91px 24.54px 24.54px 24.54px;\n    background-color: #fff;\n    box-shadow: 0 4px 4px 2px rgba(0, 0, 0, 0.05);\n\n    iframe {\n      width: 100%;\n      height: 100%;\n      border-radius: 4.91px 24.54px 24.54px 24.54px;\n    }\n  }\n\n  @media (max-width: 768px) {\n    &__header {\n      height: 176px;\n      background-image: linear-gradient(25deg, #9285f9 0%, #cd5be8 100%);\n      padding: 0 16px;\n      margin: 0 -16px;\n\n      .breadcrump {\n        display: none;\n      }\n    }\n\n    &__body-mobile {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 24px;\n      padding-top: 16px;\n\n      .text-container {\n        text-align: left;\n      }\n    }\n  }\n  @media (min-width: 769px) {\n    &__header {\n      border-radius: 8px;\n      justify-content: space-evenly;\n      padding: 0 16px;\n\n      .back-page {\n        display: none;\n      }\n    }\n\n    .media-container {\n      max-width: 50%;\n      height: 380px;\n      margin: 30px 30px 30px 0;\n    }\n\n    .text-container {\n      padding-top: 30px;\n    }\n\n    .image-container {\n      width: 50%;\n      padding: 30px 30px 30px 0;\n    }\n  }\n}\n\n.wrapper-pill-internal {\n  @media (min-width: 560px) {\n    padding-top: 15px;\n\n  }\n  @media (min-width: 1024px) {\n    padding: {\n      left: 30px;\n      right: 30px;\n    }\n  }\n  @media (min-width: 1280px) {\n    padding: {\n      left: 80px;\n      right: 80px;\n      bottom: 50px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
